export default "__VITE_ASSET__dwL$5gsa__"